import actions from './skip-slide.actions'
import getters from './skip-slide.getters'
import state from './skip-slide.state'
import mutations from './skip-slide.mutations'

export default {
  namespaced: true,
  actions,
  getters,
  state,
  mutations,
}
